import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TileIcon from '../components/TileIcon';
import './css/ItemTypeControl.css';

class ItemTypeControl extends Component {
	constructor(props) {
		super(props);

		this.handleSelected = this.handleSelected.bind(this);
	}

	handleSelected = id => {
		this.props.selectItemType(id);
	}

	render() {
		return (
			<div className="item-types">
				<TileIcon
					id={-1}
					className={`${this.props.itemTypeId === -1 ? "selected" : ""}`}
					borderColour={0}
					backColour={-1}
					textColour={0}
					tileText="ALL"
					title="Show all"
					onSelected={this.handleSelected}
				/>
				{this.props.items.map(item =>
					<TileIcon
						key={item.id}
						id={item.id}
						className={`${!item.hasData ? "disabled" : ""} ${item.id === this.props.itemTypeId ? "selected" : ""}`}
						borderColour={item.backColour}
						backColour={item.backColour}
						textColour={item.textColour}
						tileText={item.tileText}
						title={item.description}
						onSelected={this.handleSelected}
						disabled={!item.hasData}
					/>
				)}
			</div>
		);
	}
}

ItemTypeControl.propTypes = {
	itemCategory: PropTypes.string,
	items: PropTypes.arrayOf(PropTypes.any),
	itemTypeId: PropTypes.number,
	selectItemType: PropTypes.func.isRequired
};

export default connect()(ItemTypeControl);